import { createRoot } from "react-dom/client";
import { Example } from "./demo";

const root = createRoot(document.getElementById("root"));
root.render(<Example />);
